<!--
 * @Author: cmchiu
 * @Date: 2022-05-03 15:33:50
 * @LastEditTime: 2023-06-28 10:24:19
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \campus2022\campus2022-ClientApp\src\components\NewActive\newactive.vue
 * 
-->
<template>
    <div class="newactive">
        <!-- COMING SOON  (首頁沒有活動, 顯示"籌備中") -->
        <div v-if="configs.showMore && newActLs.length === 0" class="row justify-content-center comingsoon">
            <div class="col-lg-12">
                <div>
                    <img :src="`${baseUrl}assets/images/nodata.png`" alt="COMING SOON" />
                </div>
                <p>
                    COMING SOON<br />
                    近期校內活動正在籌備規劃中，請敬啟期待。
                </p>
                <a @click="$router.push('/activities')" title="回顧之前活動快訊" tabindex="0"> 回顧之前活動快訊 </a>
            </div>
        </div>
        <!-- COMING SOON  End -->

        <!-- 首頁8格 -->
        <div v-else-if="configs.showMore && newActLs.length > 0" class="row justify-content-center">
            <div v-for="item in newActLs" :key="item.BoardID" class="col-lg-3 col-md-6 col-12 pl-0 pr-0">
                <div class="row event_inner">
                    <div class="col-xl-4 col-lg-5 col-md-3 col-sm-3 col-4">
                        <img v-if="item.imgThumbnail && item.imgThumbnail != ''" :src="item.imgThumbnail" alt="" />
                    </div>
                    <div
                        @click="viewContent('1000310006000001', item.BoardID, item.TitleC)"
                        class="col-xl-8 col-lg-7 col-md-9 col-sm-9 col-8 event_class"
                        :title="item.TitleC"
                        tabindex="0"
                        role="link"
                    >
                        <span>{{ item.StartDate }}</span>
                        <p v-html="item.TitleC"></p>
                    </div>
                    <!-- <div class="col-lg-12 mt-2 event_class_time">
                        上課時間:2022/03/30(三)19:00-21:00
                    </div> -->
                </div>
            </div>

            <div class="col-lg-12 mt-5">
                <div class="more_info">
                    <a @click="$router.push('/activities')" title="更多公告" tabindex="0">更多公告</a>
                </div>
            </div>
        </div>

        <!-- 更多公告 -->
        <div
            v-else-if="!configs.showMore"
            class="row mb-30-none"
            :style="`min-height:100px; height:${configs.height}; overflow-y:${configs.overflow};`"
            v-infinite-scroll="getNewActiveList"
            :infinite-scroll-distance="1"
            :infinite-scroll-disabled="scrollLoad"
            v-loading.body.lock="loading"
            element-loading-text="加載中"
            element-loading-background="rgba(255, 255, 255, 0.5)"
            element-loading-custom-class="loading-mask"
        >
            <div v-for="item in newActLs" :key="item.BoardID" class="col-lg-4 col-md-6 col-12">
                <div class="row event_inner">
                    <div class="col-lg-4 col-md-3 col-3">
                        <img v-if="item.imgThumbnail && item.imgThumbnail != ''" :src="item.imgThumbnail" alt="" />
                    </div>
                    <div
                        @click="viewContent('1000310006000001', item.BoardID, item.TitleC)"
                        class="col-lg-8 col-md-9 col-9 event_class"
                        :title="item.TitleC"
                        tabindex="0"
                        role="link"
                    >
                        <span>{{ item.StartDate }}</span>
                        <p v-html="item.TitleC"></p>
                    </div>
                    <!-- <div class="col-lg-12 mt-2 event_class_time">
                        上課時間:2022/03/30(三)19:00-21:00
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import XEUtils from 'xe-utils'
import { getNewActiveList } from '@/api/campus'

export default {
    name: 'newActive',

    props: {
        height: {
            type: [String, Number],
            default: 180,
        },

        overflow: {
            type: String,
            default: 'overlay',
        },

        pageSize: {
            type: [String, Number],
            default: 8,
        },

        pageLimit: {
            type: [String, Number],
            default: 0,
        },

        showMore: {
            type: Boolean,
            default: false,
        },
    },

    data: function () {
        return {
            baseUrl: process.env.BASE_URL,
            configs: {
                height: XEUtils.isNumber(this.height) ? `${this.height}px` : this.height,
                overflow: this.overflow,
                pageLimit: XEUtils.isNumber(this.pageLimit) ? this.pageLimit : XEUtils.toNumber(this.pageLimit),
                showMore: this.showMore,
            },
            newActLs: [],
            newsPage: 1,
            newsPageSize: XEUtils.isNumber(this.pageSize) ? this.pageSize : XEUtils.toNumber(this.pageSize),
            newsTotalPage: 1,
            loading: false,
            scrollLoad: true,
            alreadyCall: null,
        }
    },

    created: function () {
        this.getNewActiveList().then(() => {
            this.scrollLoad = false
        })
    },

    methods: {
        async getNewActiveList() {
            const vm = this
            const alreadyCall = vm.alreadyCall
            vm.scrollLoad = true
            if (vm.newsPage <= vm.newsTotalPage && alreadyCall === null && vm.scrollLoad) {
                vm.alreadyCall = vm.newsPage
                vm.loading = true
                let params = {
                    blockID: '1000310006000001',
                    widgetnum: vm.newsPageSize,
                    page: vm.newsPage,
                    orderDateFirst: !vm.configs.showMore,
                    // descDate: true,
                    // startDateLimit: false,
                    endDateLimit: vm.configs.showMore,
                }
                await getNewActiveList(params)
                    .then(res => {
                        if (res.Code === 1) {
                            // vm.newActLs = res.Items
                            if (vm.configs.pageLimit !== 0) {
                                vm.newsTotalPage = vm.configs.pageLimit
                            } else {
                                vm.newsTotalPage = Math.ceil(res.TotalResult / vm.newsPageSize)
                            }

                            XEUtils.arrayEach(res.Items, item => {
                                vm.newActLs.push(item)
                            })
                            // console.log('NewActive:', res.Items)
                            // console.log('ActivePage:', `${vm.newsPage} / ${vm.newsTotalPage}`)
                            // vm.$message({
                            //     message: res.Msg,
                            //     type: 'success',
                            // })
                        }
                        vm.alreadyCall = null
                        vm.loading = false
                    })
                    .finally(() => {
                        vm.newsPage++
                        vm.scrollLoad = false
                    })
            } else {
                if (vm.configs.pageLimit === 0)
                    vm.$message({
                        message: '已經沒有更多消息了',
                        type: 'warning',
                    })
            }
        },

        viewContent(blockID, boardID, title) {
            this.$store.dispatch('app/cachePNTitle', title)
            this.$router.push(`/activities/postnews?QueryBoardId=${boardID}&blockid=${blockID}`)
        },
    },
}
</script>

<style scoped lang="scss">
::-webkit-scrollbar {
    width: 7px;
}

::-webkit-scrollbar-button {
    background: transparent;
    border-radius: 4px;
}

::-webkit-scrollbar-track-piece {
    background: transparent;
}

::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.3);
    border: 0 solid slategrey;
}

::-webkit-scrollbar-track {
    box-shadow: transparent;
}
</style>
